import { render, staticRenderFns } from "./BlockListRelatedContent.vue?vue&type=template&id=e2aae1aa&"
import script from "./BlockListRelatedContent.vue?vue&type=script&lang=js&"
export * from "./BlockListRelatedContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports